import { FormActions } from '@common';
import {
  MultiSelectField,
  TextareaField,
  TextField,
} from '@hypeit-gmbh/hypeit-ui';
import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { COMPANY_TAG_VALUES } from './data';

type CompanyFormFieldsPropsType = {
  onClose: () => void;
};

export const CompanyFormFields: React.FC<CompanyFormFieldsPropsType> = ({
  onClose,
}) => {
  const { t } = useTranslation('companyDetailsGeneral');

  const tagOptions = COMPANY_TAG_VALUES.map((tag) => ({
    value: tag,
    label: t(`TAGS.${tag}`, { ns: 'companies' }),
  }));

  return (
    <Stack gap="xs">
      <TextField
        fieldName="name"
        label={t('EDIT_COMPANY_MODAL.FIELDS.COMPANY_NAME')}
        required
      />
      <TextField
        fieldName="shortName"
        label={t('EDIT_COMPANY_MODAL.FIELDS.SHORTNAME')}
      />
      <TextField
        fieldName="website"
        label={t('EDIT_COMPANY_MODAL.FIELDS.WEBSITE')}
      />
      <TextField
        fieldName="vatId"
        label={t('EDIT_COMPANY_MODAL.FIELDS.VAT_ID')}
      />
      <MultiSelectField
        fieldName="tags"
        label={t('EDIT_COMPANY_MODAL.FIELDS.TAGS')}
        data={tagOptions}
        searchable
      />
      <TextareaField
        fieldName="notes"
        label={t('EDIT_COMPANY_MODAL.FIELDS.NOTES')}
      />
      <FormActions
        onCancel={onClose}
        saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
        cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
      />
    </Stack>
  );
};
